import React, { useEffect, useState } from "react";
import { IScheduling } from "../../interfaces/IScheduling";
import { ISubscription } from "../../interfaces/ISubscription";
import { IContract } from "../../interfaces/IContract";
import { Box, Collapse, Grid, MenuItem, Tab, Tabs } from "@mui/material";
import { CustomeTextField } from "../core/CustomeTextField";
import { getIsAdmin } from "../core/helper";
import { CustomTabPanel, a11yProps } from "../core/CustomTabPanel";
import { IExtension } from "../../interfaces/IExtension";
import { Extension } from "@mui/icons-material";
import { ExtensionTable } from "../Subscription/Childs/ExtensionTable";
import { ICompany } from "../../interfaces/ICompany";


interface IProps {
    editContract: IContract;
    setEditContract: Function;
    companyArray: ICompany[] ;
    extensionArray: IExtension[];
    schedulingArray: IScheduling[];
    subscriptionArray: ISubscription[];
}



export const ContractEdit:React.FC<IProps> = ({editContract, setEditContract, companyArray, extensionArray, schedulingArray, subscriptionArray}) => {
    const isAdmin = getIsAdmin();
    //
    const [orgContract,setOrgContract] = useState(editContract);
    //
    const [currentPage,setCurrentPage] = useState(0);
    //
    const [assignedExtension,setAssignedExtension] = useState(editContract.Assigned_Extension);

    const handleChangeSubscription = (changedContract:IContract) => {
        let testSubscription = subscriptionArray.find(x => x.id === changedContract.Subscription);

        if (editContract.Subscription !== null && changedContract.Subscription === null) {
            setEditContract({
                ...editContract,
                Assigned_Apps: [],
                Assigned_Module: [],
                selling_price: 0,
                isFreeAll: false,
                Scheduling: 1,
                contract_title: "",
                Subscription: null
            } as IContract)
            setAssignedExtension([]);
        }
        else if (testSubscription !== undefined) {
            setEditContract({
                ...editContract,
                Assigned_Extension: testSubscription.Assigned_Extension,
                selling_price: testSubscription.selling_price,
                isFreeAll: testSubscription.isFreeAll,
                Scheduling: testSubscription.Scheduling,
                contract_title:`Vertrag: ${testSubscription.subscription_name}`,
                Subscription: testSubscription.id
            } as IContract)
            setAssignedExtension(testSubscription.Assigned_Extension);
        }
    }


    useEffect(() => {
        let selling_price = Number(editContract.selling_price);

        if (editContract.Subscription === null) {
            if (extensionArray.length > 0 && editContract.Assigned_Extension !== assignedExtension) {
                selling_price += extensionArray
                    .filter(x => assignedExtension.indexOf(x.id) > -1)
                    .map(x => Number(x.selling_price))
                    .reduce((a,b) => a+b,0)
            }

        }

        setEditContract({
            ...editContract,
            Assigned_Extension: assignedExtension,
            selling_price: selling_price
        } as IContract)
    },[assignedExtension])


    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setCurrentPage(newValue);
    };


    return(
        <>
            <Collapse in={editContract.id > 0}  sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                    <Grid item sm={4}>
                        <b>Vertragsnummer</b>
                    </Grid>
                    <Grid item sm={8}>
                        {editContract.contract_number}
                    </Grid>

                    <Grid item sm={4}>
                        <b>Lizenz</b>
                    </Grid>
                    <Grid item sm={8}>
                        {editContract.license_key}
                    </Grid>
                </Grid>
            </Collapse>

            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item sm={12}>
                    <CustomeTextField
                        label="Firma"
                        attr="Company"
                        type="select"
                        object={editContract}
                        setObject={setEditContract}
                        required
                        disabled={editContract.id > 0}
                    >
                        {companyArray.map(comp =>
                            <MenuItem
                                key={`select-company-${comp.id}`}
                                value={comp.id}
                            >
                                {comp.company_name}
                            </MenuItem>
                        )}
                    </CustomeTextField>
                </Grid>

                <Grid item sm={12}>
                    <CustomeTextField
                        label="Abonnement"
                        attr="contract_title"
                        type="string"
                        object={editContract}
                        setObject={setEditContract}
                        required
                        disabled={editContract.id > 0}
                    />
                </Grid>


                <Grid item sm={6}>
                    <CustomeTextField
                        label="Paket"
                        attr="Scheduling"
                        type="select"
                        object={editContract}
                        setObject={setEditContract}
                        disabled={editContract.id > 0}
                    >
                        {schedulingArray.map(x =>
                            <MenuItem key={`select-scheduling-${x.id}`} value={x.id}>
                                {x.scheduling}
                            </MenuItem>
                        )}
                    </CustomeTextField>
                </Grid>
                <Grid item sm={6}>
                    <CustomeTextField
                        label="Paket"
                        attr="Subscription"
                        type="select"
                        object={editContract}
                        setObject={handleChangeSubscription}
                        disabled={editContract.id > 0}
                        null
                    >
                        {subscriptionArray.map(x =>
                            <MenuItem key={`select-subscription-${x.id}`} value={x.id}>
                                {x.subscription_name}
                            </MenuItem>
                        )}
                    </CustomeTextField>
                </Grid>


                <Grid item sm={4}>
                    <CustomeTextField
                        label="Alles inklusive"
                        attr="isFreeAll"
                        type="boolean"
                        object={editContract}
                        setObject={setEditContract}
                        required
                    />
                </Grid>

                <Grid item sm={8}>
                    <CustomeTextField
                        label="Preis"
                        attr="selling_price"
                        type="number"
                        object={editContract}
                        setObject={setEditContract}
                        required
                        disabled={editContract.id > 0}
                    />
                </Grid>

                <Grid item sm={4}>
                    <CustomeTextField
                        label="Unterschrieben"
                        attr="signed_at"
                        type="date"
                        object={editContract}
                        setObject={setEditContract}
                        required
                        disabled={editContract.id > 0}
                    />
                </Grid>
                <Grid item sm={4}>
                    <CustomeTextField
                        label="Vertrag ab"
                        attr="active_at"
                        type="date"
                        object={editContract}
                        setObject={setEditContract}
                        required
                        disabled={editContract.id > 0}
                    />
                </Grid>
                <Grid item sm={4}>
                    <CustomeTextField
                        label="Gekündigt"
                        attr="closed_at"
                        type="date"
                        object={editContract}
                        setObject={setEditContract}
                        disabled={!isAdmin || orgContract.closed_at !== null}
                    />
                </Grid>
            </Grid>


            <Box sx={{ width: '100%', mt: 5 }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={currentPage} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Erweiterungen" {...a11yProps(0)} />
                    </Tabs>
                </Box>

                <CustomTabPanel value={currentPage} index={0}>
                    <ExtensionTable
                        editSubscription={editContract}
                        extensionArray={extensionArray}
                        assignedExtension={assignedExtension}
                        setAssignedExtension={setAssignedExtension}
                        disableBtn={false}
                    />
                </CustomTabPanel>


            </Box>
        </>
    )
}